export default __webpack_public_path__ + "static/N0256-06df18cf588cd68fa8f965eb16af15df.png";